import React from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { ModalType } from '../../states/modals/ModalType.constants'
import { Modal } from './index'

const StyledExternalWebsiteModal = styled(Modal)`
  width: calc(100% - 1rem);
  height: calc(100% - 1rem);
`

const StyledIFrame = styled.iframe`
  width: 100%;
  height: 100%;
`

const ExternalWebsiteModal = () => {
  const { modalType, data } = useSelector(({ modals }) => modals)
  if (modalType !== ModalType.EXTERNAL_WEBSITE) {
    return null
  }

  const { url, title } = data
  return (
    <StyledExternalWebsiteModal header={`${title} Website`}>
      <StyledIFrame src={url} title={title} />
    </StyledExternalWebsiteModal>
  )
}

export { ExternalWebsiteModal }
